export const LOCALE_PREFIX =
    'components.Dialog.components.GroupMembersImport.components.ImportResultsTable.components.ReasonCell'
